<!-------------------------------------
|   Author: Kartik Mukati            |
|   Date: 17-04-2023                 |
--------------------------------------->

<!-- ########################## INTRODUCTORY CONTAINER COMPONENT-3 ########################## -->
<div class="conf-lob-selection-title">
    <div class="conf-inner-title">
        <div class="conf-osp-route conf-sec-1" (click)="routeToTml()">
             <img class="conf-navHeaderTitle" src="{{confAWSUrlStr}}/common/tml_logo_new.svg">
        </div>
        <div class="conf-sec-2" (click)="routeToOSP()">
            <img class="conf-tml-logo" src="{{confAWSUrlStr}}/common/fleetverse_logo_solid_wide.svg">
        </div>
        <div class="conf-sec-3" >
            <img class="conf-navHeaderTitle" src="{{confAWSUrlStr}}/common/login_menu.svg">
        </div>
    </div>
</div>

<div class="welcome-section" *ngIf="selectedLob == ''">
    <div class="conf-entry-section">
        <div class="conf-entry-point conf-entry-lob-space">
            <div class="square-T">
                <img src="{{confAWSUrlStr}}/common/square_t_border.svg" class="t-image-icon">
            </div>
            <div class="conf-horizontal-line"></div>
            <div class="conf-vertical-line"></div>
            <div class="conf-bottom-horizontal-line"></div>
            <div class="conf-bottom-vertical-line"></div>
          <!-- <div class="conf-entry-title"> -->
            <div class="conf-entry-title">
                <h2>
                    Welcome to the TATA Commercial Vehicle Configurator
                </h2>
                <h5 class="conf-entry-desired-vehicle">Please select desired vehicle category</h5>
            </div>

            <div class="conf-entry-body conf-entry-lob-body">
                <div class="row">
                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12">
                        <div class="conf-lob-box-sec" (click)="lobSelected('hcv')"
                            routerLinkActive="router-link-active">
                            <div class="conf-lob-box conf-hcv-lob">
                                <div class="conf-lob-background">
                                    <img src="{{confAWSUrlStr}}/common/webp_banners/hcv-banner.webp" alt="img-land">
                                </div>
                                <div class="conf-background-title">
                                    <h3>Heavy Trucks</h3>
                                    <div class="conf-button-sec">
                                        <button type="button" class="btn conf-configure-button">Configure Now</button>
                                    </div>
                                    <!-- <p>Trucks, Tippers & Tractor Trailers</p> -->
                                </div>
                                <div class="conf-background-btn">
                                    <!-- <div class="conf-button-sec">
                                        <button type="button" class="btn conf-configure-button">Configure Now</button>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12">
                        <div class="conf-lob-box-sec" (click)="lobSelected('ilmcv')">
                            <div class="conf-lob-box conf-ilmcv-lob">
                                <div class="conf-lob-background">
                                    <img src="{{confAWSUrlStr}}/common/webp_banners/ilmcv-banner.webp" alt="img-land">
                                </div>
                                <div class="conf-background-title">
                                    <h3>Light, Intermediate and Medium Duty Trucks</h3>
                                    <!-- <p>Trucks & Tippers</p> -->
                                    <div class="conf-button-sec">
                                        <button type="button" class="btn conf-configure-button">Configure Now</button>
                                    </div>
                                </div>
                                <div class="conf-background-btn">
                                    <!-- <div class="conf-button-sec">
                                        <button type="button" class="btn conf-configure-button">Configure Now</button>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12">
                        <div class="conf-lob-box-sec" (click)="lobSelected('scv')">
                            <div class="conf-lob-box conf-scv-lob">
                                <div class="conf-lob-background">
                                    <img src="{{confAWSUrlStr}}/common/webp_banners/scv-cargo-banner.webp"
                                        alt="img-land">
                                </div>
                                <div class="conf-background-title">
                                    <h3>SCV Cargo and Pickups</h3>
                                    <!-- <p>Ace, Intra, Yodha</p> -->
                                    <div class="conf-button-sec">
                                        <button type="button" class="btn conf-configure-button">Configure Now</button>
                                    </div>
                                </div>
                                <div class="conf-background-btn">
                                    <!-- <div class="conf-button-sec">
                                        <button type="button" class="btn conf-configure-button">Configure Now</button>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12">
                        <div class="conf-lob-box-sec" (click)="lobSelected('bus')">
                            <div class="conf-lob-box conf-bus-lob">
                                <div class="conf-lob-background">
                                    <img src="{{confAWSUrlStr}}/common/webp_banners/bus-banner.webp" alt="img-land">
                                </div>
                                <div class="conf-background-title">
                                    <h3>Buses</h3>
                                    <!-- <p>Chassis and Fully Built Buses</p> -->
                                    <div class="conf-button-sec">
                                        <button type="button" class="btn conf-configure-button">Configure Now</button>
                                    </div>
                                </div>
                                <div class="conf-background-btn">
                                    <!-- <div class="conf-button-sec">
                                        <button type="button" class="btn conf-configure-button">Configure Now</button>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12">
                        <div class="conf-lob-box-sec" (click)="lobSelected('winger')">
                            <div class="conf-lob-box conf-winger-lob">
                                <div class="conf-lob-background">
                                    <img src="{{confAWSUrlStr}}/common/webp_banners/winger-banner.webp" alt="img-land">
                                </div>
                                <div class="conf-background-title">
                                    <h3>Winger</h3>
                                    <!-- <p>Staff, Tours & Travel, School, Ambulance</p> -->
                                    <div class="conf-button-sec">
                                        <button type="button" class="btn conf-configure-button">Configure Now</button>
                                    </div>
                                </div>
                                <div class="conf-background-btn">
                                    <!-- <div class="conf-button-sec">
                                        <button type="button" class="btn conf-configure-button">Configure Now</button>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12">
                        <div class="conf-lob-box-sec" (click)="lobSelected('magic')">
                            <div class="conf-lob-box conf-winger-lob">
                                <div class="conf-lob-background">
                                    <img src="{{confAWSUrlStr}}/common/webp_banners/magic-banner.webp" alt="img-land">
                                </div>
                                <div class="conf-background-title">
                                    <h3>Magic</h3>
                                    <!-- <p>Passenger, School, Ambulance</p> -->
                                    <div class="conf-button-sec">
                                        <button type="button" class="btn conf-configure-button">Configure Now</button>
                                    </div>
                                </div>
                                <div class="conf-background-btn">
                                    <!-- <div class="conf-button-sec">
                                        <button type="button" class="btn conf-configure-button">Configure Now</button>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="conf-introductory-body" ngClass="conf-{{selectedLob}}" *ngIf="showGetStart === true">
    <video autoplay>
        <source src="{{confAWSUrlStr}}/common/lob_landing.webm" type="video/mp4">
    </video>
    <div class="layer">
        <div class="introductory-logo-section d-flex justify-content-center">
            <img src="{{confAWSUrlStr}}/common/conf-logo-tm.png" class="introductory-logo-tm" loading="eager" />
        </div>
        <div class="container introductory-action-content-box">
            <div class="introductory-wrapper">
                <div class="row text-center">
                    <p class="introductory-action-content-text" [innerHTML]="lobMsg"> </p>
                </div>
                <div class="row w-100 justify-content-center introductory-action-btn-box"
                    (click)="start_configurator(selectedLob)">
                    <div class="introductory-action-button">
                        <p class="introductory-action-button-text">Get Started </p>
                        <img src="assets/configurator/icons/conf-chevron-right.png" loading="lazy" />
                        <!-- //dk -->
                    </div>
                    <div class="introductory-image-scv">
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
<!-- ########################## INTRODUCTORY CONTAINER COMPONENT-3 ########################## -->
